// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"698":"a099ee4d","845":"b44c29c0"}[chunkId] + ".chunk.js";
};